import React, { createContext, useContext, useMemo, useState } from 'react'
import { correctionalFacilityId, geoData } from '@fs/zion-config'
import { useCanAddPersonalData } from '@fs/zion-permissions'
import { useFeatureFlag } from '@fs/zion-flags'
import { splunk } from '@fs/zion-splunk-logger'
import { usePrisonReportsPermission } from '../hooks/usePermission'
import uuid from '../utils/uuid'

export const AppContext = createContext({})
const key = 'give-clientId'

export const AppProvider = ({ children }) => {
  const [shareablePage, setShareablePage] = useState(false)
  const [skipLinkId, setSkipLinkId] = useState(null)
  const [canAddPersonalData] = useCanAddPersonalData()
  const { hasPermission, loading } = usePrisonReportsPermission()
  const clientId = window.localStorage.getItem(key) || uuid()
  const accessFromPrison = !!correctionalFacilityId && typeof correctionalFacilityId === 'string'
  const reportAccessFlag = useFeatureFlag('give_corrections_report_access')
  const prisonLoggingFlag = useFeatureFlag('give_corrections_logging')

  const value = useMemo(
    () => ({
      accessFromPrison,
      clientId,
      correctionalFacilityId,
      setShareablePage,
      shareablePage,
      skipLinkId,
      setSkipLinkId,
      geoCountry: geoData?.country,
      canAddPersonalData,
      prisonReportsPermission: { hasPermission: hasPermission && reportAccessFlag.isOn, loading },
    }),
    [
      accessFromPrison,
      clientId,
      shareablePage,
      canAddPersonalData,
      hasPermission,
      loading,
      reportAccessFlag,
      skipLinkId,
    ]
  )

  if (prisonLoggingFlag.isOn && prisonLoggingFlag.config.correctionalFacilityIdLogging) {
    splunk.log({
      message: 'app-provider:correctional-facility-id',
      correctionalFacilityId,
      accessFromPrison,
    })
  }

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export const useAppProvider = () => {
  return useContext(AppContext)
}
